import DESetup from "../components/desktop/DE/DESetup";

type Props = {};

function DE(Props: Props) {
  return <DESetup />;
}

export default DE;
